// extracted by mini-css-extract-plugin
module.exports = {"browseBtn":"PriceListModal_browseBtn__2g1Be"};